import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/msalConfig';
import { fetchSurveys, type SurveyListItem } from '../../api/surveyApi';
import { SurveyResponseRates } from './SurveyResponseRates';

export function ResponseRatesPage() {
  const { instance, accounts } = useMsal();
  const [surveys, setSurveys] = useState<SurveyListItem[]>([]);
  const [selectedId, setSelectedId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
        const data = await fetchSurveys(r.accessToken);
        // Only surveys that have actually run (have a start date) are useful here.
        const ran = data.filter(s => s.startsAt != null);
        setSurveys(ran);
        if (ran.length > 0) setSelectedId(ran[0].id);
      } catch {
        // leave empty
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <p style={{ color: 'var(--color-text-muted)' }}>Loading surveys…</p>;

  if (surveys.length === 0) {
    return (
      <div style={{ maxWidth: 480 }}>
        <p style={{ color: 'var(--color-text-muted)' }}>
          No surveys have been delivered yet. Deliver a survey from the{' '}
          <a href="/admin/surveys" style={{ color: 'var(--color-primary)' }}>Surveys</a> page to see response rates here.
        </p>
      </div>
    );
  }

  const selected = surveys.find(s => s.id === selectedId);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem', whiteSpace: 'nowrap' }}>Response Rates</h1>
        <select
          value={selectedId}
          onChange={e => setSelectedId(e.target.value)}
          style={{
            padding: '0.4rem 0.75rem',
            fontSize: '0.95rem',
            border: '1px solid var(--color-border)',
            borderRadius: 6,
            background: 'var(--color-surface)',
            minWidth: 260,
          }}
        >
          {surveys.map(s => (
            <option key={s.id} value={s.id}>
              {s.importLabel ?? s.title}
              {s.isImported ? ' (imported)' : ''}
              {s.closedAt ? ` · closed ${new Date(s.closedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}` : ' · live'}
            </option>
          ))}
        </select>
      </div>

      {selected && <SurveyResponseRates surveyId={selected.id} />}
    </div>
  );
}
